import React from 'react';

import type { CardPaymentFormProps } from '../../types';
import { CARD_FIELD_SPACING, CardFormFields, CardFormRoot } from '../../styles';
import { BillingAddressFields } from '../BillingAddressFields';
import { CardIdentityFields } from '../CardIdentityFields';
import { CardPaymentActions } from '../CardPaymentActions';
import { CardSecurityFields } from '../CardSecurityFields';
import { ForeignBuyerAlert } from '../ForeignBuyerAlert';
import { InstallmentsField } from '../InstallmentsField';
import { useCardPaymentForm } from './useCardPaymentForm';

export const CardPaymentForm = (props: CardPaymentFormProps) => {
  const { paymentOption, transactable, onPaid } = props;
  const {
    control,
    errors,
    visibility,
    installmentOptions,
    canSubmit,
    submitting,
    lookingUpAddress,
    lookUpAddress,
    submit,
  } = useCardPaymentForm({ paymentOption, transactable, onPaid });

  const disabled = submitting || lookingUpAddress;

  return (
    <CardFormRoot onSubmit={submit} noValidate data-testid='card-payment-form'>
      <ForeignBuyerAlert visible={visibility.showForeignAlert} />

      <CardFormFields container spacing={CARD_FIELD_SPACING} alignItems='flex-start'>
        <CardIdentityFields
          control={control}
          errors={errors}
          visibility={visibility}
          disabled={disabled}
          onZipCodeChange={lookUpAddress}
          lookingUpAddress={lookingUpAddress}
        />

        {visibility.showBillingAddress ? (
          <BillingAddressFields control={control} errors={errors} disabled={disabled} />
        ) : null}

        <CardSecurityFields control={control} errors={errors} visibility={visibility} disabled={disabled} />

        <InstallmentsField
          control={control}
          errors={errors}
          installmentOptions={installmentOptions}
          visible={visibility.showInstallments}
          disabled={disabled}
        />
      </CardFormFields>

      <CardPaymentActions canSubmit={canSubmit} submitting={submitting} />
    </CardFormRoot>
  );
};

export default CardPaymentForm;
